import { Injectable } from '@angular/core';
import { ModeModelBase, ModeModelInjectables } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

class SearchModel extends ModeModelBase {
  override _name = 'search';

  constructor(injectables: ModeModelInjectables) {
    super(injectables);
  }
}

@Injectable({ providedIn: 'root' })
export class SearchModelAccessor extends ModelAccessorBase<SearchModel> {
  override name: 'search';

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.search');
  }

  createModel(resource, opts?) {
    const model = new SearchModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
